export enum GridConnectionType {
  TRANSMISSION = 'TRANSMISSION',
  DISTRIBUTION = 'DISTRIBUTION',
}
export const gridConnectionTypeToLabel = {
  [GridConnectionType.TRANSMISSION]: 'Transmission',
  [GridConnectionType.DISTRIBUTION]: 'Distribution',
};
